import I18N from '@leverege/i18n'
import React from 'react'

import AisleSessions from './AisleSessions'
import AisleSessionModel from './AisleSessionModel'

const id = 'ps.dataViewers.AisleSessionSupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.AisleSessionSupport',
  name : tf( 'name', 'Aisle Session Support' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'GroupDataViewer', objectType : 'aisle' },
  createSettings : ( props ) => {
    return AisleSessionModel.create()
  },
  render : ( props ) => {
    return React.createElement( AisleSessions, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
